import { put, takeLatest, fork, select } from "redux-saga/effects";
import { constants, actions } from "./index";
import { actions as authActions } from "../auth/login/index";
import { getAuthToken, getUserData } from "../auth/login/selector";
import { getLocale } from "./selector";
import isAuthenticatedSession from "../../../lib/auth/isAuthenticatedSession";
import * as translations from "../../../translations/";
import ApiClient from "../../../api/ApiClient";
import { actions as menuActions } from "../menu";
import { fetchMarketingMessagesRoutine } from "../marketingMessages";
import { fetchMarketingBarsRoutine } from "../marketingBars";
import { fetchOffersRoutine } from "../plans";

function* fetchTranslations() {
  const locale = yield select(getLocale);

  try {
    let response = yield ApiClient.get({
      urlPath: "app.translations",
      variables: {
        locale
      }
    });

    const data = {
      ...translations[locale],
      ...response.data
    };

    yield put(actions.fetchTranslationsSuccess(locale, data));
  } catch (error) {
    yield put(actions.fetchTranslationsError(error));
  }
}

function* fetchMarketTranslations() {
  try {
    const { data } = yield ApiClient.get({
      urlPath: "app.stockSeoData.getMarketList"
    });

    yield put(actions.fetchMarketTranslationsSuccess(data));
  } catch (error) {
    yield put(actions.fetchMarketTranslationsError(error));
  }
}

function* refreshLocaleDependencies() {
  yield put(actions.resetTranslations());
  yield put(menuActions.fetchMenu());
  yield put(fetchMarketingMessagesRoutine());
  yield put(fetchMarketingBarsRoutine());
  yield put(fetchOffersRoutine());
  yield fetchTranslations();
}

function* onApplyLocale() {
  yield refreshLocaleDependencies();
}

function* onSetLocale() {
  const locale = yield select(getLocale);
  const authToken = yield select(getAuthToken);
  const userData = yield select(getUserData);

  yield refreshLocaleDependencies();

  if (!isAuthenticatedSession({ authToken, userData })) {
    return;
  }

  try {
    yield ApiClient.put({
      urlPath: "app.auth.setLocale",
      variables: {
        locale
      }
    });

    yield put(authActions.refreshUserData({ skipAffiliation: true }));
  } catch (error) {
    console.error(error);
  }
}

function* watchGetTranslations() {
  yield takeLatest(constants.FETCH_TRANSLATIONS, fetchTranslations);
  yield takeLatest(constants.APPLY_LOCALE, onApplyLocale);
  yield takeLatest(constants.SET_LOCALE, onSetLocale);

  yield takeLatest(
    constants.FETCH_MARKET_TRANSLATIONS,
    fetchMarketTranslations
  );
}

export default [fork(watchGetTranslations)];
